import React, { useEffect, useState, useRef } from "react";
import { api } from "@/api";

/**
 * Spinner central exibido enquanto houver requisições HTTP pendentes.
 * Substitui a antiga barra de carregamento do topo — mais visível e
 * com delay pequeno para não piscar em requests muito rápidas.
 */
let pending = 0;
const listeners = new Set();
const SHOW_DELAY_MS = 350; // só aparece se demorar mais que isso (evita flicker)

function notify() { listeners.forEach(fn => fn(pending > 0)); }

function attachInterceptors() {
  if (attachInterceptors._done) return;
  attachInterceptors._done = true;
  api.interceptors.request.use(cfg => { pending++; notify(); return cfg; });
  api.interceptors.response.use(
    (resp) => { pending = Math.max(0, pending - 1); notify(); return resp; },
    (err)  => { pending = Math.max(0, pending - 1); notify(); return Promise.reject(err); }
  );
}

export default function LoadingSpinner() {
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    attachInterceptors();
    const fn = (v) => setActive(v);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  useEffect(() => {
    if (active) {
      // delay para evitar flash em requests rápidas
      timerRef.current = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    } else {
      clearTimeout(timerRef.current);
      setVisible(false);
    }
    return () => clearTimeout(timerRef.current);
  }, [active]);

  if (!visible) return null;
  return (
    <div
      aria-hidden="true"
      data-testid="global-loading-spinner"
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9998,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          border: "4px solid rgba(29, 161, 255, 0.18)",
          borderTopColor: "#1DA1FF",
          borderRightColor: "#6B3BFF",
          animation: "spinner-rotate 0.7s linear infinite",
          boxShadow: "0 4px 20px rgba(29, 161, 255, 0.25)",
          background: "rgba(255,255,255,0.6)",
          backdropFilter: "blur(4px)",
        }}
      />
    </div>
  );
}
